// extracted by mini-css-extract-plugin
export var accordionChevron = "XboxOnboardPage-module__accordionChevron___E5weD";
export var accordionChevronOpen = "XboxOnboardPage-module__accordionChevronOpen___7sITD";
export var accordionContent = "XboxOnboardPage-module__accordionContent___qQjXT";
export var accordionHeader = "XboxOnboardPage-module__accordionHeader___-gt9N";
export var accordionHeaderLeft = "XboxOnboardPage-module__accordionHeaderLeft___1wwKB";
export var accordionIcon = "XboxOnboardPage-module__accordionIcon___HZxmU";
export var accordionSection = "XboxOnboardPage-module__accordionSection___EpH1V";
export var accordionSubtitle = "XboxOnboardPage-module__accordionSubtitle___NdveK";
export var accordionTitle = "XboxOnboardPage-module__accordionTitle___egym3";
export var blockedRegionMessage = "XboxOnboardPage-module__blockedRegionMessage___x7JmQ";
export var businessTypeCard = "XboxOnboardPage-module__businessTypeCard___8n1HA";
export var businessTypeCardSelected = "XboxOnboardPage-module__businessTypeCardSelected___klUGK";
export var businessTypeDescription = "XboxOnboardPage-module__businessTypeDescription___jKXeJ";
export var businessTypeField = "XboxOnboardPage-module__businessTypeField___umTBh";
export var businessTypeGroup = "XboxOnboardPage-module__businessTypeGroup___Rwa5W";
export var businessTypeHeader = "XboxOnboardPage-module__businessTypeHeader___npXQG";
export var businessTypeInstructions = "XboxOnboardPage-module__businessTypeInstructions___tWXwE";
export var businessTypeLegend = "XboxOnboardPage-module__businessTypeLegend___ipeeG";
export var businessTypeNotice = "XboxOnboardPage-module__businessTypeNotice___tSjy0";
export var businessTypeNoticeIcon = "XboxOnboardPage-module__businessTypeNoticeIcon___qczBW";
export var businessTypeNoticeText = "XboxOnboardPage-module__businessTypeNoticeText___8t5ed";
export var businessTypeOptions = "XboxOnboardPage-module__businessTypeOptions___bWnEI";
export var businessTypeStatus = "XboxOnboardPage-module__businessTypeStatus___lrljj";
export var businessTypeText = "XboxOnboardPage-module__businessTypeText___jNWxB";
export var businessTypeTitle = "XboxOnboardPage-module__businessTypeTitle___PP222";
export var cancelButton = "XboxOnboardPage-module__cancelButton___-Xgsu";
export var clipboardWrapper = "XboxOnboardPage-module__clipboardWrapper___v3iOw";
export var contextualStoreBackgroundDark = "#1a1b1e";
export var countryCodePrefix = "XboxOnboardPage-module__countryCodePrefix___PCJz2";
export var enrollmentActions = "XboxOnboardPage-module__enrollmentActions___3Mxj7";
export var enrollmentDescription = "XboxOnboardPage-module__enrollmentDescription___zjn18";
export var enrollmentSection = "XboxOnboardPage-module__enrollmentSection___IHWPc";
export var enrollmentSpinner = "XboxOnboardPage-module__enrollmentSpinner___5AxVn";
export var enrollmentTitle = "XboxOnboardPage-module__enrollmentTitle___LvM6p";
export var fieldHint = "XboxOnboardPage-module__fieldHint___VRLEt";
export var fieldTooltip = "XboxOnboardPage-module__fieldTooltip___HhFPV";
export var fieldTooltipButton = "XboxOnboardPage-module__fieldTooltipButton___KXh5f";
export var fieldTooltipCard = "XboxOnboardPage-module__fieldTooltipCard___rcpSM";
export var formGrid = "XboxOnboardPage-module__formGrid___GxxhV";
export var formGroup = "XboxOnboardPage-module__formGroup___GXE5g";
export var formGroupFull = "XboxOnboardPage-module__formGroupFull___F64ll";
export var formInput = "XboxOnboardPage-module__formInput___qzC1c";
export var formLabel = "XboxOnboardPage-module__formLabel___Iftl6";
export var formLabelRow = "XboxOnboardPage-module__formLabelRow___pX0Mc";
export var instructionItem = "XboxOnboardPage-module__instructionItem___8gP8q";
export var instructionsList = "XboxOnboardPage-module__instructionsList___7Q7So";
export var ndaPendingContainer = "XboxOnboardPage-module__ndaPendingContainer___Y6b7d";
export var ndaPendingImage = "XboxOnboardPage-module__ndaPendingImage___-w2dM";
export var ndaPendingMessage = "XboxOnboardPage-module__ndaPendingMessage___VbzzR";
export var ndaPendingTitle = "XboxOnboardPage-module__ndaPendingTitle___bg3eC";
export var pageSubtitle = "XboxOnboardPage-module__pageSubtitle___ueYUW";
export var pageTitle = "XboxOnboardPage-module__pageTitle___4sS7w";
export var partnerIdentitySection = "XboxOnboardPage-module__partnerIdentitySection___IEHqc";
export var partnerNameRow = "XboxOnboardPage-module__partnerNameRow___kdb+F";
export var partnerNameSection = "XboxOnboardPage-module__partnerNameSection___Wxc0r";
export var phoneInputRow = "XboxOnboardPage-module__phoneInputRow___4BseD";
export var programCard = "XboxOnboardPage-module__programCard___IvLba";
export var programCardContent = "XboxOnboardPage-module__programCardContent___hY5nm";
export var programCardDescription = "XboxOnboardPage-module__programCardDescription___n2F3o";
export var programCardImage = "XboxOnboardPage-module__programCardImage___XQzUl";
export var programCardTitle = "XboxOnboardPage-module__programCardTitle___iabn5";
export var programsGrid = "XboxOnboardPage-module__programsGrid___PDnIV";
export var programsSubtitle = "XboxOnboardPage-module__programsSubtitle___Fh7fC";
export var requiredMark = "XboxOnboardPage-module__requiredMark___Dufem";
export var resourcesGrid = "XboxOnboardPage-module__resourcesGrid___jeHM8";
export var resourcesSection = "XboxOnboardPage-module__resourcesSection___GVN84";
export var resourcesTitle = "XboxOnboardPage-module__resourcesTitle___ryXXg";
export var screenReaderOnly = "XboxOnboardPage-module__screenReaderOnly___46mZ9";
export var sectionBox = "XboxOnboardPage-module__sectionBox___4GA5M";
export var sectionTitle = "XboxOnboardPage-module__sectionTitle___-aE+o";
export var sellerIdNotice = "XboxOnboardPage-module__sellerIdNotice___u6zbe";
export var spinnerContainer = "XboxOnboardPage-module__spinnerContainer___J1N2G";
export var statusError = "XboxOnboardPage-module__statusError___EEqel";
export var statusInfo = "XboxOnboardPage-module__statusInfo___VcyH1";
export var statusMessage = "XboxOnboardPage-module__statusMessage___d76yW";
export var statusWarning = "XboxOnboardPage-module__statusWarning___evqZm";
export var studioNameRow = "XboxOnboardPage-module__studioNameRow___Iw-Cd";
export var submitActions = "XboxOnboardPage-module__submitActions___iCUmP";
export var submitButton = "XboxOnboardPage-module__submitButton___s6Dpb";
export var submitHint = "XboxOnboardPage-module__submitHint___5NQgf";
export var submitRow = "XboxOnboardPage-module__submitRow___uIFmu";
export var termsCheckbox = "XboxOnboardPage-module__termsCheckbox___OGUTn";
export var termsLabel = "XboxOnboardPage-module__termsLabel___cbICS";
export var termsLink = "XboxOnboardPage-module__termsLink___zQSEc";
export var termsSection = "XboxOnboardPage-module__termsSection___WWpMM";
export var validateButton = "XboxOnboardPage-module__validateButton___CoK4D";
export var validationError = "XboxOnboardPage-module__validationError___CXFM0";
export var validationPending = "XboxOnboardPage-module__validationPending___ma51i";
export var validationSuccess = "XboxOnboardPage-module__validationSuccess___DtcMb";